/*
 * Copyright (c) 2024-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import Mousetrap from "../../libraries/ShortcutHandling.js";
import DisplayIcon from "../Icons/DisplayIcon.jsx";
import {Subscription} from "../../Subscription.js";


class DisplayShortcut extends Component {
    constructor() {
        super();
        this.state = {
            wasPressed: false
        }
        this.sub = new Subscription()
    }


    displayKey(key) {
        let {wasPressed} = this.state
        switch (key) {
            case "command":
                return (<div
                    className={`px-2 py-1 bg-white border font-mono text-sm flex  justify-center items-center rounded text-stone-600 ${(wasPressed && ("border-blue-500"))}`}>
                    <DisplayIcon iconName={"ImCommand"}/></div>)
            case "option":
                return (<div
                    className={`px-2 py-1 bg-white border font-mono text-sm flex justify-center items-center rounded text-stone-600 ${(wasPressed && ("border-blue-500"))}`}>
                    <DisplayIcon iconName={"BsOption"}/></div>)
            case "shift":
                return (<div
                    className={`px-2 py-1 bg-white border font-mono text-sm flex  justify-center items-center rounded text-stone-600 ${(wasPressed && ("border-blue-500"))}`}>
                    <DisplayIcon iconName={"BsShift"}/></div>)
            case "click":
                return (<div
                    className={`px-2 py-1 bg-white border font-mono text-sm flex  justify-center items-center rounded text-stone-600 ${(wasPressed && ("border-blue-500"))}`}>
                    <DisplayIcon iconName={"TbHandClick"}/></div>)
            case "backspace":
                return (<div
                    className={`px-2 py-1 bg-white border font-mono text-sm flex  justify-center items-center rounded text-stone-600 ${(wasPressed && ("border-blue-500"))}`}>
                    <DisplayIcon iconName={"IoBackspaceOutline"}/></div>)
            case "left":
                return (<div
                    className={`px-1 py-1 bg-white border font-mono text-sm flex  justify-center items-center rounded text-stone-600 ${(wasPressed && ("border-blue-500"))}`}>
                    <DisplayIcon iconName={"TbChevronLeft"}/></div>)
            case "right":
                return (<div
                    className={`px-1 py-1 bg-white border font-mono text-sm flex  justify-center items-center rounded text-stone-600 ${(wasPressed && ("border-blue-500"))}`}>
                    <DisplayIcon iconName={"TbChevronRight"}/></div>)
            case "up":
                return (<div
                    className={`px-1 py-1 bg-white border font-mono text-sm flex  justify-center items-center rounded text-stone-600 ${(wasPressed && ("border-blue-500"))}`}>
                    <DisplayIcon iconName={"TbChevronUp"}/></div>)
            case "down":
                return (<div
                    className={`px-1 py-1 bg-white border font-mono text-sm flex  justify-center items-center rounded text-stone-600 ${(wasPressed && ("border-blue-500"))}`}>
                    <DisplayIcon iconName={"TbChevronDown"}/></div>)
            case "scroll":
                return (<div
                    className={`px-1 py-1 bg-white border font-mono text-sm flex  justify-center items-center rounded text-stone-600 ${(wasPressed && ("border-blue-500"))}`}>
                    <DisplayIcon iconName={"PiMouseScroll"}/></div>)
            case "tab":
                return (<div
                    className={`px-1 py-1 bg-white border font-mono text-sm flex  justify-center items-center rounded text-stone-600 ${(wasPressed && ("border-blue-500"))}`}>
                    <DisplayIcon iconName={"TbArrowBarToRight"}/></div>)

            default:
                return (<div
                    className={`px-1 bg-white flex justify-center items-center text-xs border font-mono  rounded text-stone-600 ${(wasPressed && ("border-blue-500"))}`}>{key}</div>)

        }

    }

    componentDidMount() {
        let {shortcuts = []} = this.props

        // this has to be bound to the window to prevent overlap with the real commands
        this.sub.add(() => Mousetrap.bind(shortcuts, (e) => {
            this.setState({wasPressed: true})
        }));

    }

    componentWillUnmount() {
        this.sub.unmount()
    }


    render() {
        let {shortcuts = []} = this.props

        return (
            <div className={"flex select-none items-center"}>
                {shortcuts.map((shortcut, index) => {
                    const keys = shortcut.split("+");
                    return (
                        <React.Fragment key={index}>
                            {keys.map((key, index2) => (
                                <React.Fragment key={index2}>
                                    {this.displayKey(key)}
                                    {index2 < keys.length - 1 && (
                                        <div className={"font-mono text-sm text-stone-400 self-center mx-2"}> + </div>
                                    )}
                                </React.Fragment>
                            ))}
                            {index < shortcuts.length - 1 && (
                                <div className={"font-mono text-sm text-stone-400 self-center mx-2"}> OR </div>
                            )}
                        </React.Fragment>
                    );
                })}
            </div>
        );
    }
}

DisplayShortcut.propTypes = {};

export default DisplayShortcut;